import { QueryClient } from '@tanstack/react-query';
import isNil from 'lodash-es/isNil';
import queryCache from './queryCache';
const queryClient = new QueryClient({
    queryCache,
    defaultOptions: {
        queries: {
            staleTime: 120 * 1000,
            retry: (failureCount, error) => {
                if ('status' in error) {
                    const e = error;
                    return (
                    // retry if attemps are under 4 and status is not 4XX or 5XX
                    (failureCount <= 3 && !(e.status > 399 && e.status < 600)) ||
                        // retry one time if 502|503|504 if we retry 3 time it increase backend outage by adding load on an unstable server
                        (failureCount === 1 && e.status > 501 && e.status < 505));
                }
                else {
                    return failureCount <= 3;
                }
            }
        }
    }
});
export const invalidateQueries = (keys) => {
    if (!isNil(keys)) {
        queryClient.invalidateQueries({
            predicate: ({ queryKey }) => keys.some((key) => `${queryKey[0]}`.startsWith(`${key[0]}`))
        });
    }
};
export const invalidateQueriesContainingPattern = (pattern) => {
    if (!isNil(pattern)) {
        queryClient.invalidateQueries({
            predicate: ({ queryKey }) => `${queryKey[0]}`.includes(`${pattern}`)
        });
    }
};
export const deleteQueriesContainingPattern = (pattern) => {
    if (!isNil(pattern)) {
        queryClient.removeQueries({
            predicate: ({ queryKey }) => `${queryKey[0]}`.includes(`${pattern}`)
        });
    }
};
export default queryClient;
